module.exports = __webpack_public_path__ + "img/account.95e6fa7e.svg";